import * as Sentry from '@sentry/react'
import { extraErrorDataIntegration } from '@sentry/browser'
import { useEffect } from 'react'
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes } from 'react-router-dom'

const sentryDsn = import.meta.env.VITE_RUNTIME_SENTRY_DSN
const environment = import.meta.env.VITE_RUNTIME_SENTRY_ENV || import.meta.env.MODE
const commitRef = import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA || import.meta.env.VITE_GITHUB_SHA

Sentry.init({
  dsn: sentryDsn,
  environment,
  release: commitRef,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    extraErrorDataIntegration(),
  ],
  tracesSampleRate: 1,
  attachStacktrace: true,
  replaysSessionSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
})
